import * as types from "./index";

export function setEntityName(state = "dashboard") {
  return {
    type: types.SET_ENTITY_NAME,
    payload: { state }
  };
}
